import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})


// TODO, service is currently emulating HTTpClient behavior, it should be createEvent, deleteEvent. shouldnt be return response status
export class ContributorService {

  // This url need to be changed during the make process in the release pipeline
  private eventEndpoint: string = environment.contributor.uri;
  constructor(private http: HttpClient, private config: ConfigService) {
  }

  putEvent(event, metaData: any): Observable<Object> {

    let url = `${this.eventEndpoint}`;

    var headers = {
      'Content-Type': 'application/json'

    }

    
    for(var prop in metaData){
      headers[prop] = metaData[prop];
    }

    var httpOptions = {
      headers: new HttpHeaders(headers)
    };

    return this.http.post(url, event, httpOptions)
      .pipe(
        retry(5),
        catchError(this.config.handleError)
      )
    ;
  }

  deleteEvent(id): Observable<Object> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    let url = `${this.eventEndpoint}/${id}`
    return this.http.delete(url, httpOptions)
    .pipe(
      retry(5),
      catchError(this.config.handleError)
    );

  }

}
